export default [
	{
		path: "/settings/static-urls",
		component: () => import("../views/Settings/StaticURLs/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/static-urls/edit",
		component: () => import("../views/Settings/StaticURLs/Edit.vue"),
		meta: {
			//hasmainmenu: true
		}
	},
    {	path: "/settings/static-urls/edit/:id?",
		component: () => import("../views/Settings/StaticURLs/Edit.vue"),
	},
    {
        path: "/static-urls/:token?",
		component: () => import("../views/StaticURL/Submit.vue"),
		meta: {
			hasmainmenu: true
		} 
    }
]